import { HiCalendarDays } from "react-icons/hi2";

export const CalendarIcon = ({ width, height, color, ...props }) => (
  <HiCalendarDays
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
